<template>
	<div class="base-model">
		<div class="page-title">
			<icon-font class="title-icon" type="icon-jichumoxing" style="margin-right: 12px"/>
			<span>Dashboard</span>
			<a-radio-group v-model="mode" class="show-type">
				<a-radio-button value="list">列表</a-radio-button>
				<a-radio-button value="view">大图</a-radio-button>
			</a-radio-group>
		</div>
		<a-spin :spinning="loading">
			<div class="view-box" v-if="mode === 'view'">
				<a-row justify="space-between" type="flex" class="view-top">
					<a-select
						v-model="nowIndex"
						:filter-option="false"
						@change="refreshView"
						style="width: 200px"
					>
						<a-select-option
							v-for="(item,i) in data"
							:key="item.analysisTemplateId"
							:value="i"
						>
							{{ item.name }}
						</a-select-option>
					</a-select>
					<!-- <div class="name">
						<span>当前：{{data[nowIndex].name}}</span>
						<span v-if="nextObj">下一个：{{nextObj.name}}</span>
					</div> -->
					<div class="btns">
            <a-tooltip placement="top" title="复制">
							<a-button class="btn-tertiary" @click="copyClick(data[nowIndex])"> 
								<icon-font type="icon-icon-copy"/>
							</a-button>
						</a-tooltip>
            <a-tooltip placement="top" title="全屏">
							<a-button class="btn-tertiary" @click="viewClick(data[nowIndex])">
								<icon-font type="icon-icon-fullscreen"/>
							</a-button>
						</a-tooltip>
					</div>
				</a-row>
				<div class="view-box-content" ref="content">
					<a-icon type="arrow-left" class="pre-model" @click="nowIndex--,refreshView()" v-if="preObj"/>
					<a-icon type="arrow-right" class="next-model" @click="nowIndex++,refreshView()" v-if="nextObj"/>
					<ModelViewer v-if="data[nowIndex]" :reportCode="data[nowIndex].analysisTemplateId" ref="modelViewer"  :contentWidth="contentWidth" :isbase="false"></ModelViewer>
				</div>
			</div>
			<div class="model-list" style="min-height: 400px" v-if="mode === 'list'">
				<div class="model-list-item" v-for="record in data" :key="record.analysisTemplateId">
					<div class="item-top">
						<icon-font :type="record.customOptions?record.customOptions.icon:''"/>
						<span>{{record.name}}</span>
					</div>
					<div class="item-center" @click="viewClick(record)">
						<img :src="record.customOptions?record.customOptions.pictureUrl:''" alt="" srcset="">
					</div>
					<div class="item-bottom">
						<span>创建时间: <span v-if="record.createTime">{{record.createTime.slice(0,11)}}</span></span>
						<div class="copy-btn" @click="copyClick(record)"> 
							<icon-font type="icon-Copy"/>
							<span>复制</span>
						</div>
					</div>
				</div>
			</div>
		</a-spin>
	</div>
</template>
<script>
import { getSysDefaultTemplates, copyBaseTemplate } from '@/api/template'
import ModelViewer from '@/views/bigscreenDesigner/viewer/index.vue'

export default {
	name: 'baseModel',
	data() {
		return {
			activeKey: 'data',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 50,
        showTotal: total => `共${total}条`
			},
			params: {
				name: ''
			},
			mode: 'view',
			nowIndex: 0,
			filterVisible: false,
			data: [],
			contentWidth: 0
		}
	},
	computed: {
		nextObj() {
			return this.data[this.nowIndex + 1]
		},
		preObj() {
			return this.data[this.nowIndex - 1]
		}
	},
	methods: {
		refreshView() {
			let data = this.data
			this.data = []
			this.$nextTick(() => {
				this.data = data
			})
		},
		// 复制
		copyClick(record) {
      this.$confirm({
				icon: () => <a-icon type="exclamation-circle" style="color: #4278FF" theme="filled"/>,
        title: '复制此基础模型',
        content: '复制基础模型后，系统将会在你的自定义模型中新建一个相同的模型；你可以在此模型中自定义任何字段来完成你的业务报告。',
				okText: '复制并编辑',
        onOk: () => {
					copyBaseTemplate(record.analysisTemplateId).then(res => {
						gtag('event', 'base_model_copy', {
							modelName: record.name,
						});	
						this.editClick({
							analysisTemplateId: res.data
						})
					})
				},
      });
    },
		// 预览
		viewClick(record) {
			let backUrl = `${location.origin}${location.pathname}?mode=${this.mode}&nowIndex=${this.nowIndex}`
      let routeUrl = this.$router.resolve({
        path: "/modelViewer",
        query: { 
					reportCode: record.analysisTemplateId, 
					isbase: false,
					backUrl
				},
      });
      window.open(routeUrl.href, "_blank");
		},
		getList() {
      this.loading = true
      getSysDefaultTemplates({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        ...this.params
      }).then((res) => {
        this.data = res.data.recordList || []
				this.$nextTick(() => {
					let content = this.$refs.content
					this.contentWidth = content?.clientWidth
				})
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
		editClick(record) {
			this.$router.push({
				name: 'modelDesign',
				query: {
					reportCode: record.analysisTemplateId
				}
			})
		}
	},
	mounted() {
		let mode = this.$route.query.mode
		let nowIndex = this.$route.query.nowIndex
		this.mode = mode || 'view'
		this.nowIndex = nowIndex?Number(nowIndex):0
		this.getList()
	},
	components: {
		ModelViewer
	}
}
</script>
<style lang="less" scoped>
	.base-model {
		height: calc(100% - 73px);
		.ant-spin-nested-loading {
			height: calc(100% - 49px);
			/deep/ .ant-spin-container {
				height: 100%;
				.view-box {
					height: 100%;
					.view-box-content {
						height: calc(100% - 56px);
					}
				}
			}
		}
	}
	.view-btn {
		margin-right: 16px;
	}
	.view-btn,.copy-btn, .edit-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
	.model-id {
		color: #9CA9CB;
		line-height: 20px;
		font-size: 12px;
	}
	.show-type {
		float: right;
		margin-right: 12px;
	}
	.view-box {
		.view-top {
			padding: 0 24px;
			& > div {
				display: inline-block;
			}
			.name {
				color: #677392;
				line-height: 32px;
				& > * {
					margin-right: 12px;
				}
			}
			.btns {
				& > * {
					margin-left: 12px;
				}
			}
		}
		/deep/ .layout::-webkit-scrollbar {
			display:none;
		}
		.view-box-content {
			border-radius: 10px;
			margin: 12px 0px;
			position: relative;
			overflow: hidden;
			max-width: 1200px;
			.next-model,.pre-model {
				position: absolute;
				font-size: 20px;
				border: 1px solid #E1E8F9;
				border-radius: 50%;
				padding: 10px;
				top: 50%;
				margin-top: -20px;
				cursor: pointer;
				z-index: 100;
			}
			.next-model {
				right: 10px;
			}
			.pre-model {
				left: 10px;
			}
		}
	}
	.model-list {
		padding: 0 12px;
		.model-list-item {
			width: 251px;
			height: 270px;
			border-radius: 12px 12px 12px 12px;
			margin: 12px ;
			opacity: 1;
			border: 1px solid #E1E8F9;
			display: inline-block;
			padding: 0 12px;
			box-sizing: border-box;
			.item-top {
				height: 48px;
				font-size: 16px;
				font-weight: 500;
				color: #13234C;
				line-height: 24px;
				display: flex;
				align-items: center;
				.anticon {
					font-size: 20px;
					margin-right: 6px;
				}
			}
			.item-center {
				height: 178px;
				cursor: pointer;
				overflow: hidden;
				text-align: center;
				img {
					width: 100%;
				}
			}
			.item-bottom {
				height: 48px;
				width: 133px;
				font-size: 12px;
				font-weight: 400;
				color: #677392;
				line-height: 20px;
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.copy-btn {
					border-radius: 4px 4px 4px 4px;
					border: 1px solid #22AC35;
					width: 66px;
					font-size: 14px;
					padding: 0;
					cursor: pointer;
					line-height: 24px;
					display: inline-block;
					height: 24px;
					color: #22AC35;
					.anticon {
						margin-left: 8px;
						margin-right: 8px;
					}
					// &:hover {
					// 	span {
					// 		color: #22AC35;
					// 	}
					// }
				}
			}
		}
	}
	@media screen  and (max-width:1600px) {
		.model-list .model-list-item {
			width: 240px;
			height: 270px;
		}
	}
	@media screen  and (min-width:1600px) and (max-width:1900px) {
		.model-list .model-list-item {
			width: 250px;
			height: 270px;
		}
	}
	@media screen  and (min-width:1900px) {
		.model-list .model-list-item {
			width: 251px;
			height: 270px;
		}
	}
</style>